export default __webpack_public_path__ + "static/media/moneyStacks.d9b45d17.svg";